import router from "./index";
import {
    isMobile
} from "@/utils";
import Vue from "vue";
import wxShare from "@/mixins/wxShare";
let hasPath;

//路由字典，  h5 和 PC 的映射关系
let routeDict = {
    // pc name : h5  name
    'encyclopedias': 'index', //首页
    'articleItem': 'articleDetailm', //文章详情
    'entrylists': 'entryListm', // 词条总目
    'entryItem': 'entryListDetailm', // 词条详情
    'menuslist': 'entryCategoryItemm', // 词条分类总目
    'extendlist': 'extendListm', // 扩展阅读
    'tunnelVideo': 'videoList', // 词条分类总目
    'entryList': 'searchresult', //模糊查询结果页
}

router.beforeEach((to, from, next) => {
    // console.log(to, from)
    let isPC = !isMobile()

    let toName = to.name;

    let h5Names = Object.values(routeDict)
    let pCNames = Object.keys(routeDict)
    if (isPC) { //PC
        let index = h5Names.findIndex(item => toName === item)
        if (index > -1) { //来自h5，做PC映射
            next({
                name: pCNames[index],
                params: to.params,
                query: to.query,
                replace: true
            })
        } else { //来自PC
            next()
        }

    } else {
        let index = pCNames.findIndex(item => toName === item)
        if (index > -1) { //来自PC，做h5映射
            next({
                name: h5Names[index],
                params: to.params,
                query: to.query,
                replace: true
            })
        } else { //来自h5
            next()
        }

    }

    // 获取上一个页面的路由
    hasPath = from.path;
    Vue.prototype.$hasPath = hasPath;
    next()
})

router.afterEach((to, from) => {
    const BASEURL = window.location.href.split('#')[0]
    const config = {
        title: document.title,
        desc: '',
        imgUrl: "",
        // 当前网站加密url传参，后端鉴权接收时对应解密
        link: BASEURL,
        // 分享的url链接，安全域名和这个分享进入的域名要一致
        shareLink: location.href
    }
    // 启用分享
    wxShare.updateWxShareConfig(config)

})